import React, { Component } from 'react';
import { onUnsubClick } from '../../../utils/helper';

class RoFooter extends Component {
    render() {
        const uid = JSON.parse(sessionStorage.getItem('uid'));
        const lang = sessionStorage.getItem('lang');
        const msisdn = sessionStorage.getItem("msisdn");
        const rockmanId = sessionStorage.getItem('rockmanId');

        const withdrawLink = `https://checksubscription.com/withdraw?c=ro&product=ro.mobioastro.com&country=ro&language=${lang}&portalSource=ro.mobioastro.com&rockmanId=${rockmanId}&msisdn=${msisdn}`;

        return (
            <div>
                <a href="http://n.mobioastro.com/ro/tnc-mobioastro?offer=1" target="_blank">Termeni și condiții</a> | <a href='' onClick={onUnsubClick} target="_blank">Anulare</a> | <a href={withdrawLink} target="_blank">Retragere din Contract</a>
            </div>
        );
    }
}

export default RoFooter;


// WEBPACK FOOTER //
// ./src/mobioastro/components/footer/rofooter.js